import React, {Component} from 'react';
import Validator from "../../../../../../utilities/Validator";
import ReactTooltip from 'react-tooltip'
import ReactNotify from 'react-notify'

export default class CenyBiletowMacierz extends Component {
    constructor(props) {
        super(props);

        let editedCell = null;

        if (this.props.editable){
            editedCell = 'cell1-1'
        }

        this.state = {
            editedCell: editedCell,
            nowa_cena: ''
        };
        this.ustawKomorkeDoEdytowania = this.ustawKomorkeDoEdytowania.bind(this)
        this.ustawNastepnaKomorkeDoEdytowania = this.ustawNastepnaKomorkeDoEdytowania.bind(this)
        this.renderCellContent = this.renderCellContent.bind(this)
        this.onZapiszNowaCene = this.onZapiszNowaCene.bind(this)
        this.__onKeyPress = this.__onKeyPress.bind(this)
        this.onChangeNowaCena = this.onChangeNowaCena.bind(this)
    }


    componentWillReceiveProps(nextprops) {
        if (Boolean(nextprops.ponowneWyszukanie)) {

            let trs = document.getElementsByClassName('selectedRow')

            for (let i = 0; i < trs.length; i++) {
                trs[i].className = ''
            }

            this.setState({editedCell: null})
            this.props.handleDezaktywujPonowneWyszukiwanie();
        }
    }

    renderCellContent(miejscowosc_od, index_od, miejscowosc_do, index_do) {
        if (index_od === 0 && index_do === 0) {
            return (
                <div style={{textAlign: 'center', fontSize: '20px', lineHeight: '2em'}}>
                    <sub>do</sub>
                    <span style={{margin: '0 3px'}}>/</span>
                    <sup>od</sup>
                </div>
            )
        } else if (index_od === 0) {
            return (
                <div className={'nazwa_miejscowosci_do'}>
                    {miejscowosc_do.nazMi}
                </div>
            )
        } else if (index_do === 0) {
            return (
                <div className={'nazwa_miejscowosci_od'}>
                    {miejscowosc_od.nazMi}
                </div>
            )
        } else if (index_do <= index_od) {

            let cena = this.props.cennik.find(c => c.idMiDo === miejscowosc_od.idMi && c.idMiOd === miejscowosc_do.idMi)
            if (cena) {
                if (Boolean(cena.cena)) {

                    if (this.state.editedCell === 'cell' + index_od + '-' + index_do) {
                        return (
                            <div className={'pole_ceny'}>
                                <input defaultValue={cena.cena} autoFocus onChange={this.onChangeNowaCena}
                                       onKeyPress={(e) => this.__onKeyPress(e, miejscowosc_od, miejscowosc_do, cena)}/>
                            </div>
                        )
                    } else {
                        return (
                            <div className={'pole_ceny'}>
                                {cena.cena}
                            </div>
                        )
                    }
                } else {
                    if (this.state.editedCell === 'cell' + index_od + '-' + index_do) {
                        return (
                            <div className={'pole_ceny'}>
                                <input type={'number'} defaultValue={''} autoFocus onChange={this.onChangeNowaCena}
                                       onKeyPress={(e) => this.__onKeyPress(e, miejscowosc_od, miejscowosc_do, cena)}/>
                            </div>
                        )
                    } else {
                        return (
                            <div className={'pole_ceny'}>
                                <span style={{
                                    background: 'red',
                                    fontWeight: 'bold',
                                    color: 'white',
                                    padding: '1px 5px',
                                    border: '1px solid firebrick',
                                    borderRadius: '2px'
                                }}>
                                    +
                                </span>
                            </div>
                        )
                    }
                }
            } else {
                if (this.state.editedCell === 'cell' + index_od + '-' + index_do) {
                    return (
                        <div className={'pole_ceny'}>
                            <input type={'number'} defaultValue={''} autoFocus onChange={this.onChangeNowaCena}
                                   onKeyPress={(e) => this.__onKeyPress(e, miejscowosc_od, miejscowosc_do, null)}/>
                        </div>
                    )
                } else {
                    return (
                        <div className={'pole_ceny'}>
                                <span style={{
                                    background: 'red',
                                    fontWeight: 'bold',
                                    color: 'white',
                                    padding: '1px 5px',
                                    border: '1px solid firebrick',
                                    borderRadius: '2px'
                                }}>
                                    +
                                </span>
                        </div>
                    )
                }
            }
        } else {
            return ' '
        }
    }

    onChangeNowaCena(e) {
        this.setState({nowa_cena: e.target.value})
    }

    podswietlWiersz(cell) {

        let trs = document.getElementsByClassName('selectedRow')

        for (let i = 0; i < trs.length; i++) {
            trs[i].className = ''
        }

        document.getElementById(cell).parentElement.className = 'selectedRow';

    }

    ustawKomorkeDoEdytowania(cell) {
        if (this.props.editable) {
            this.podswietlWiersz(cell)

            if (this.state.editedCell !== cell) {
                this.setState({editedCell: cell})
            }
        } else {
            this.refs.notificator.error('Nie można edytować cennika z datą wsteczną', "", 3000)
        }
    }

    ustawNastepnaKomorkeDoEdytowania() {

        /*
        * pierwsza cyfra index1 - leci po osi Y
        * druga cyfra index2 - leci po osi X
        * */

        if (Boolean(this.state.editedCell)) {
            let poprzednia = this.state.editedCell;

            let myslnik = poprzednia.indexOf('-');

            let index1 = parseInt(poprzednia.substr(4, 1));
            if (myslnik === 6) {
                index1 = parseInt(poprzednia.substr(4, 2))
            }

            let index2 = parseInt(poprzednia.substr(myslnik + 1, poprzednia.length - 1))

            if (this.props.miejscowosci.length - 1 === index2 && this.props.miejscowosci.length - 1 === index1) {
                //index1 = 1; index2 = 1;     // ustawienie na poczatek
                this.setState({editedCell: 'cell1-1'});
                this.podswietlWiersz('cell1-1')

            } else if (this.props.miejscowosci.length - 1 === index2 || index1 === index2) {
                // ustawienie na poczatek nastepnego wiersza
                index1 = index1 + 1;
                index2 = 1;

                this.setState({editedCell: 'cell' + index1 + '-' + index2});
                this.podswietlWiersz('cell' + index1 + '-' + index2)

            } else {
                // ustawienie na nastepna na prawo komorke
                index2 = index2 + 1;
                this.setState({editedCell: 'cell' + index1 + '-' + index2});
                this.podswietlWiersz('cell' + index1 + '-' + index2)

            }
        }
    }

    onZapiszNowaCene(miejscowoscOd, miejscowoscDo, obecna_cena) {
        /*
        * gdy obecna_cena jest null - dodanie ceny
        * gdy nie jest nullem - edycja istniejącej ceny
        * */

        let val = (this.state.nowa_cena).toString();
        if (Boolean(obecna_cena)) {

            if (this.state.nowa_cena === '') {
                val = Boolean(obecna_cena.cena) ? (obecna_cena.cena).toString() : null  // gdy nie uzupelniono w inpucie ceny nastepuje przypisanie starej wartosci, by nie wyzerowalo
            }
        }
        if (Boolean(val)) {
            if (val.indexOf(',') > -1) {
                val = val.replace(',', '.');
            }

            if (val >= 0 && Validator.validateIntOrDouble(val)) {
                this.props.handleEdytujCene(miejscowoscOd, miejscowoscDo, val, obecna_cena)
                this.setState({nowa_cena: ''})
                this.ustawNastepnaKomorkeDoEdytowania()
            } else {
                console.log('niepoprawna liczba')
            }
        } else {
            this.ustawNastepnaKomorkeDoEdytowania()
        }

    }

    __onKeyPress = (e, miejscowoscOd, miejscowoscDo, obecna_cena) => {
        if (e.key === 'Enter') {
            this.onZapiszNowaCene(miejscowoscOd, miejscowoscDo, obecna_cena);
        }
    }

    render() {

        return (
            <div>
                <ReactNotify ref='notificator'/>
                <div id={'macierz_trasy'}>
                    <table className={'table'}>

                        {
                            this.props.miejscowosci.map((miejscowosc_od, index_od) => {
                                return (
                                    <tr>
                                        {
                                            this.props.miejscowosci.map((miejscowosc_do, index_do) => {
                                                return (
                                                    <td className={Boolean(index_od === 0) ? 'contener_nazwa_miejscowosci_do' : ''}
                                                        onClick={() => {
                                                            this.ustawKomorkeDoEdytowania('cell' + index_od + '-' + index_do)
                                                        }} id={'cell' + index_od + '-' + index_do}>
                                                        <div
                                                            data-tip={miejscowosc_do.nazMi + ' -> ' + miejscowosc_od.nazMi}
                                                            data-for={"React-tooltip" + index_od + '-' + index_do}>
                                                            {this.renderCellContent(miejscowosc_od, index_od, miejscowosc_do, index_do)}
                                                            {
                                                                Boolean(index_do !== 0 && index_od !== 0) ?
                                                                    <ReactTooltip place="top" type="dark" effect="solid"
                                                                                  id={"React-tooltip" + index_od + '-' + index_do}/>
                                                                    :
                                                                    ''

                                                            }
                                                        </div>

                                                    </td>
                                                )
                                            })
                                        }
                                    </tr>
                                )
                            })
                        }
                    </table>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/cenyBiletow/pokazCennik/components/CenyBiletowMacierz.js